import {
  apiCall,
  detectOS,
  doNothing,
  getBrowserInfo,
  messageError,
} from '../util';

export function logError({
  action,
  description = '',
  endpoint,
  exception = null,
  request = null,
  response = null,
  statusCode = null,
}) {
  return (_, getState) => {
    const state = getState();
    try {
      let status = statusCode;
      if (exception && ((exception?.name === 'TimeoutError'
        || exception?.name === 'AbortError')
        || (exception.includes && exception.includes('AbortError')))) {
        status = 504;
      }

      let requestString = '';
      let responseString = '';
      try {
        if (request) {
          requestString = JSON.stringify(request);
        }
      } catch (error) {
        requestString = `INVALID JSON REQUEST: ${error}`;
      }

      try {
        if (response) {
          responseString = JSON.stringify(response);
        }
      } catch (error) {
        responseString = `INVALID JSON RESPONSE: ${error}`;
      }

      const url = 'purchase/Log/QuoteSiteError';

      const browserInfo = getBrowserInfo();
      const OS = detectOS();

      apiCall(url, {
        post: {
          Action: action,
          browser: browserInfo.name,
          Email: state?.quoting?.newCustomer?.email
            || state?.quoting?.parameters?.email,
          EmployerGuid: state?.quoting?.employerId,
          Endpoint: endpoint,
          ErrorDescription: messageError(description),
          HttpStatusCode: status,
          OperatingSystem: OS,
          Request: requestString,
          Response: responseString,
          UserAgent: navigator.userAgent,
        },
      });
    } catch (e) {
      doNothing();
    }
  };
}
